import { AxiosHeaders, InternalAxiosRequestConfig } from 'axios';

import getToken from './getToken';
import VendorUtil from '../vendorUtils';

const setAxiosHeader = (config: InternalAxiosRequestConfig<any>): InternalAxiosRequestConfig<any> => {
  (config.headers as AxiosHeaders).set('hostDomain', VendorUtil.getVendorDomain());
  (config.headers as AxiosHeaders).set('Request-Start-Time', new Date().getTime());
  if (typeof window !== 'undefined') {
    const token = localStorage && getToken();
    if (token) (config.headers as AxiosHeaders).set('Authorization', `Bearer ${token}`);
  }

  return {
    ...config,
    withCredentials: true,
  };
};

export default setAxiosHeader;
